import React from 'react';

class DataGridHeaderRow extends React.Component {
    render () {
        return (
            <div {...this.props} className={['component-data-grid-header-row', this.props.className].join(' ')}>
                { this.props.children }
            </div>
        )
    }
}

export default DataGridHeaderRow;



// WEBPACK FOOTER //
// ./web-app/components/data-grid-header-row.jsx